import App from './App';
import Actions from './Actions';
import Validations from './Validations';
import VisibilityToggler from './VisibilityToggler';
import Select2Dropdown from './Select2Dropdown';

document.addEventListener('DOMContentLoaded', () => {
  // init application
  const app = new App();
  app.init();

  const actions = new Actions();
  actions.init();

  const validations = new Validations();
  validations.init();

  const visibilityToggler = new VisibilityToggler();
  visibilityToggler.init();

  const select2Dropdown = new Select2Dropdown();
  select2Dropdown.init();
});
